import { Box, styled, Theme } from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = {
  centered?: boolean;
  spacing?: keyof Theme['spacingSizes'];
  className?: string;
  fullWidth?: boolean;
};

const shouldForwardProp = (prop: string) =>
  !['fullWidth', 'centered', 'spacing'].includes(prop);

type StyledColumnProps = Pick<Props, 'centered' | 'spacing' | 'fullWidth'>;

const StyledColumn = styled(Box, {
  shouldForwardProp,
})<StyledColumnProps>(({ theme, centered, spacing, fullWidth }) => ({
  display: 'flex',
  alignItems: centered ? 'center' : undefined,
  gap: spacing ? theme.spacing(theme.spacingSizes[spacing]) : 0,
  flexDirection: 'column',
  width: fullWidth ? '100%' : undefined,
}));

const Column: React.FC<PropsWithChildren<Props>> = ({
  children,
  spacing,
  className,
  fullWidth,
  ...props
}) => {
  return (
    <StyledColumn
      className={className}
      spacing={spacing}
      fullWidth={fullWidth}
      {...props}
    >
      {children}
    </StyledColumn>
  );
};

export default Column;
